import { createFileRoute, Outlet } from '@tanstack/react-router';
import { List } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/controls/register')({
    staticData: {
        breadcrumb: {
            title: 'Control register',
        },
        ui: {
            icon: List,
        },
    },
    component: Outlet,
});
